import { usePaymentContext } from '../contexts/PaymentContext'

export interface SMBNavState {
  isOnboarded: boolean
  hasSubscription: boolean
}

export function useSMBNavState(_user?: any, _pathname?: string) {
  try {
    const { smb, hasAnySubscription, loading } = usePaymentContext()

    return {
      smbNavState: smb
        ? {
            isOnboarded: Boolean(smb.onboarding_completed),
            hasSubscription: hasAnySubscription,
          }
        : null,
      smbNavLoading: loading,
    }
  } catch {
    return { smbNavState: null, smbNavLoading: false }
  }
}
